import { withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id", "checked", "value"]
const _hoisted_2 = ["tabindex", "aria-disabled", "aria-label", "aria-checked", "aria-labelledby", "aria-describedby"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["data-testid", "tabindex"]
const _hoisted_6 = ["data-testid", "tabindex"]
const _hoisted_7 = {
  key: 0,
  class: "checkbox-outer-container-description"
}
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "checkbox-outer-container-extra" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_t = _resolveComponent("t")!
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!
  const _directive_stripped_aria_label = _resolveDirective("stripped-aria-label")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkbox-outer-container", {
      'has-clean-tooltip': _ctx.hasTooltip,
    }]),
    "data-checkbox-ctrl": ""
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["checkbox-container", { 'disabled': _ctx.isDisabled}]),
      onKeydown: [
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.clicked($event)), ["prevent"]), ["enter"])),
        _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.clicked($event)), ["prevent"]), ["space"]))
      ],
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clicked($event)))
    }, [
      _createElementVNode("input", {
        id: _ctx.id,
        checked: _ctx.isChecked,
        value: _ctx.valueWhenTrue,
        type: "checkbox",
        tabindex: "-1",
        "aria-hidden": "true",
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["stop","prevent"]), ["enter"]))
      }, null, 40, _hoisted_1),
      _cache[6] || (_cache[6] = _createTextVNode()),
      _createElementVNode("span", {
        ref: "checkbox",
        class: _normalizeClass(["checkbox-custom", {indeterminate: _ctx.indeterminate}]),
        tabindex: _ctx.isDisabled ? -1 : 0,
        "aria-disabled": _ctx.isDisabled,
        "aria-label": _ctx.replacementLabel,
        "aria-checked": !!_ctx.value,
        "aria-labelledby": _ctx.labelKey || _ctx.label ? _ctx.idForLabel : undefined,
        "aria-describedby": _ctx.ariaDescribedBy,
        role: "checkbox"
      }, null, 10, _hoisted_2),
      _cache[7] || (_cache[7] = _createTextVNode()),
      (_ctx.$slots.label || _ctx.label || _ctx.labelKey || _ctx.hasTooltip)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(["checkbox-label", { 'checkbox-primary': _ctx.primary }])
          }, [
            _renderSlot(_ctx.$slots, "label", {}, () => [
              (_ctx.labelKey)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    id: _ctx.idForLabel,
                    class: _normalizeClass({ 'body-text-color': _ctx.useBodyTextColor })
                  }, [
                    _createVNode(_component_t, {
                      k: _ctx.labelKey,
                      raw: true
                    }, null, 8, ["k"])
                  ], 10, _hoisted_3))
                : (_ctx.label)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      id: _ctx.idForLabel,
                      class: _normalizeClass({ 'body-text-color': _ctx.useBodyTextColor })
                    }, _toDisplayString(_ctx.label), 11, _hoisted_4))
                  : _createCommentVNode("", true),
              _cache[5] || (_cache[5] = _createTextVNode()),
              (_ctx.tooltipKey)
                ? _withDirectives((_openBlock(), _createElementBlock("i", {
                    key: 2,
                    class: "checkbox-info icon icon-info icon-lg",
                    "data-testid": _ctx.componentTestid + '-info-icon',
                    tabindex: _ctx.isDisabled ? -1 : 0,
                    role: "tooltip"
                  }, null, 8, _hoisted_5)), [
                    [_directive_clean_tooltip, {content: _ctx.t(_ctx.tooltipKey), triggers: ['hover', 'touch', 'focus']}],
                    [_directive_stripped_aria_label, _ctx.t(_ctx.tooltipKey)]
                  ])
                : (_ctx.tooltip)
                  ? _withDirectives((_openBlock(), _createElementBlock("i", {
                      key: 3,
                      class: "checkbox-info icon icon-info icon-lg",
                      "data-testid": _ctx.componentTestid + '-info-icon',
                      tabindex: _ctx.isDisabled ? -1 : 0,
                      role: "tooltip"
                    }, null, 8, _hoisted_6)), [
                      [_directive_clean_tooltip, {content: _ctx.tooltip, triggers: ['hover', 'touch', 'focus']}],
                      [_directive_stripped_aria_label, _ctx.tooltip]
                    ])
                  : _createCommentVNode("", true)
            ], true)
          ], 2))
        : _createCommentVNode("", true)
    ], 34),
    _cache[8] || (_cache[8] = _createTextVNode()),
    (_ctx.descriptionKey || _ctx.description)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_ctx.descriptionKey)
            ? (_openBlock(), _createBlock(_component_t, {
                key: 0,
                id: _ctx.describedById,
                k: _ctx.descriptionKey
              }, null, 8, ["id", "k"]))
            : (_ctx.description)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  id: _ctx.describedById
                }, _toDisplayString(_ctx.description), 9, _hoisted_8))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "extra", {}, undefined, true)
    ])
  ], 2))
}